import { render, staticRenderFns } from "./Row4.vue?vue&type=template&id=fa5ae202&scoped=true"
import script from "./Row4.vue?vue&type=script&lang=js"
export * from "./Row4.vue?vue&type=script&lang=js"
import style0 from "./Row4.vue?vue&type=style&index=0&id=fa5ae202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ae202",
  null
  
)

export default component.exports